module.exports = __webpack_public_path__ + "static/img/Lance Tang.fb668e51.png";